module.exports = __webpack_public_path__ + "img/newlogo.1ae84bdd.png";